import * as React from 'react';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { GlobalNavigationLineOfBusiness } from '__generated__/api/types';

import { Header as HeaderBernie } from '@gc/global-components';

export interface HeaderProps {
  className?: string;
  searchCriteria?: SearchCriteriaModel;
}

export const Header: React.FunctionComponent<HeaderProps> = ({ className, searchCriteria }) => (
  <HeaderBernie
    className={className}
    lineOfBusiness={GlobalNavigationLineOfBusiness.HOTEL}
    customJourneyCriterias={customJourneyCriterias(searchCriteria)}
    marketing={customGoogleMarketingCriteria(searchCriteria)}
  />
);
Header.displayName = 'Header';

const customJourneyCriterias = searchCriteria => {
  let customJourneyCriteria = null;
  const { regionId, startDate, endDate } = searchCriteria || {};
  if (Number(regionId)) {
    customJourneyCriteria = [
      {
        destination: {
          regionId: regionId,
        },
        dateRange: {
          startDate: startDate,
          endDate: endDate,
        },
      },
    ];
  }

  return customJourneyCriteria;
};

const customGoogleMarketingCriteria = searchCriteria => {
  const { MDPDTL, gclid } = searchCriteria || {};

  return {
    metaDistributionPartnersDetails: MDPDTL,
    googleClickIdentifier: gclid,
  };
};
